import {
  poppins_400,
  poppins_500,
  poppins_600,
} from "@/components/common/fonts";
import { Button, Divider, Dropdown, Input } from "antd";
import styled from "styled-components";

export const VideoPageTemplateRoot = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin: 0 auto;

  max-width: 1200px;
  .video-content-item-list {
    display: flex;
    margin-top: 20px;
  }
`;

export const ShareTemplateRoot = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin: 0 auto;

  max-width: 1500px;
  .video-content-item-list {
    display: flex;
    margin-top: 20px;
  }
`;

export const VideoContentArea = styled.div`
  display: flex;
  gap: 10px;
`;

export const VideoWrapper = styled.div`
  aspect-ratio: 1142 / 640;
  .video-item {
    max-width: 1142px;
    max-height: 640px;
    width: 100%;
    height: 640px;
    aspect-ratio: 1142 / 640;
  }
`;

export const VoteButton = styled(Button)`
  display: flex;
  background-color: black;
  color: white;
  padding: 20px 30px;
  align-items: center;
`;

export const HeaderWrapper = styled.div`
  width: 100%;
  height: 100%;
  margin: 0px;
  padding: 0px;
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;

  h1.ant-typography {
    font-family: ${poppins_600.style.fontFamily};
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 20px;
    padding: 0;
    margin: 0;
    color: #222222;
    margin-top: 20px;
    flex: 1;
    text-align: right;
  }

  .button-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    gap: 10px;
    flex: 1;

    .download-button {
      width: 120px;
      height: 45px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      color: #000000;
      cursor: pointer;
      max-height: 50px;
      font-family: ${poppins_400.style.fontFamily};
      font-size: 14px;
      line-height: 20px;
      margin: 10px;
      gap: 10px;
      /* background-color: aqua; */
      &:hover {
        color: #3075f6;
      }
    }

    .share-button {
      width: 100px;
      height: 45px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #000000;
      cursor: pointer;
      max-height: 50px;
      font-family: ${poppins_400.style.fontFamily};
      font-size: 14px;
      line-height: 20px;
      margin-top: 10px;
      margin-bottom: 10px;
      gap: 10px;
      /* background-color: bisque; */
      &:hover {
        color: #3075f6;
      }
    }

    .divider {
      height: 45px;
      width: 1px;
      background-color: #cdcdcd;
      margin: 10px;
    }
  }

  .free-button {
    border-radius: 10px;
    background-color: #3075f6;
    border: 1px solid #3075f6;
    height: 40px;
    width: 140px;
    color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
    /* margin: 10px; */
    font-weight: 500;
  }

  .edit-button {
    border-radius: 10px;
    background-color: #3075f6;
    border: 1px solid #3075f6;
    height: 40px;
    width: 60px;
    color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
    /* margin: 10px; */
    font-weight: 500;
  }

  .upgrade-button {
    border-radius: 10px;
    background-color: #3075f6;
    border: 1px solid #3075f6;
    height: 40px;
    width: 90px;
    color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
    /* margin: 10px; */
    font-weight: 500;
  }

  .profile-button {
    width: 35px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    /* margin: 10px; */
  }

  /* For below 768px screen width by Jimmy*/
  @media screen and (max-width: 768px) {
    .button-wrapper {
      display: none;
    }
  }
`;

export const StyledDivider = styled(Divider)`
  color: red;
  height: 40px;
`;

export const ShareDivider = styled(Divider)`
  margin: 0px;
`;

export const CustomItem = styled.button`
  display: flex;
  width: 244px;
  height: 22px;
  align-items: center;
  /* border-bottom: 1px solid #f1f2f4; */
  padding-top: 5px;
  padding-bottom: 5px;
  /* font-weight: 500; */
  font-size: 13px;
  color: #12102d;
  column-gap: 5px;
  /* padding-left: 20px;
  padding-right: 20px; */
  background-color: transparent;
  border: none;
  cursor: pointer;
`;

export const ProfileWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
`;

export const ProfileIcon = styled.div`
  display: flex;
  width: 32px;
  height: 32px;
  background: black;
  justify-content: center;
  align-items: center;
  border-radius: 16px;
  cursor: pointer;
  /* margin-right: 5px; */

  .name {
    color: #fff;
    font-weight: 600;
    font-size: 16px;
  }
`;

export const StyledDropdown = styled(Dropdown)`
  :hover {
    background-color: white !important;
  }
`;

export const ViewsPopup = styled.div`
  width: 235px;
  height: 133px;
  border-radius: 5px;
  padding: 10px;
  background-color: white;

  .title {
    font-weight: 600;
    font-size: 14px;
    line-height: 18px;
  }

  .info {
    padding: 12px 0px;
    width: 100%;
    height: 100%;
    list-style-type: none;
    margin: 0;
    text-align: left;

    .list-wrapper {
      list-style-position: inside;
      .item {
        font-family: Poppins;
        font-size: 10px;
        font-weight: 500;
        line-height: 15px;
        letter-spacing: 0em;
        text-align: left;
      }
    }
  }
`;

export const SharePopup = styled.div`
  width: 235px;
  height: 133px;
  border-radius: 5px;
  padding: 10px;
  background-color: white;

  .title {
    font-weight: 600;
    font-size: 14px;
    line-height: 18px;
  }

  .info {
    padding: 12px 0px;
    width: 100%;
    height: 100%;
    list-style-type: none;
    margin: 0;
    text-align: left;

    .list-wrapper {
      list-style-position: inside;
      .item {
        font-family: Poppins;
        font-size: 10px;
        font-weight: 500;
        line-height: 15px;
        letter-spacing: 0em;
        text-align: left;
      }
    }
  }
`;

export const ProfileBar = styled.div`
  display: flex;
  width: 244px;
  height: 50px;
  justify-content: flex-start;
  align-items: center;
  border-bottom: 1px solid #f1f2f4;

  .icon {
    color: #fff;
    font-weight: 600;
    font-size: 16px;
    width: 32px;
    height: 32px;
    background: black;
    border-radius: 20px;
    align-items: center;
    justify-content: center;
    text-align: center;
    vertical-align: center;
    display: flex;
  }

  .info {
    margin-left: 10px;
  }
`;

export const HomeDiv = styled.div<{ isShowArrow: boolean }>`
  cursor: pointer;
  width: ${(props) => (props.isShowArrow ? "24px" : "120px")};
  height: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

export const StyledModal = styled.div<{ isWorkspaceMember: boolean }>`
  position: fixed;
  top: 70px;
  right: 100px;
  border-radius: 8px;
  padding: 0px 20px;
  z-index: 10;
  /* width: 370px; */
  width: ${(props) => (props?.isWorkspaceMember ? "370px" : "150px")};
  background-color: white;
  box-shadow: 0px 4px 10px 0px #00000040;
`;

export const StyledModalContent = styled.div`
  /* justify-content: flex-start; */
  align-items: center;

  .title {
    font-size: 16px;
    font-weight: bold;
    line-height: 20px;
  }

  .content {
    margin: 20px 0px;
    border-radius: 5px;
    background-color: #f8f9fa;
    padding: 20px 10px;

    .profile-content {
      display: flex;
      width: 100%;
      height: 40px;
      gap: 10px;
      align-items: center;
      padding: 10px 10px;
    }

    .profile-name {
      display: flex;
      flex-direction: column;
      width: 200px;
    }

    .profile-sub-name {
      display: flex;
      flex-direction: row;
      color: #44444480;
      font-size: 9px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 50%;
    }
  }

  .button-wrapper {
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    align-items: center;
    color: #000000;
    cursor: pointer;
    font-family: ${poppins_400.style.fontFamily};
    font-size: 14px;
    gap: 5px;
    padding: 10px;
  }
`;

export const ShareTemplateMain = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin: 0 auto;

  .container {
    width: 100%;
    height: 100%;
    padding: 0 30px;
    display: flex;

    .thumbnail-wrapper {
      display: flex;
      width: 100%;
      /* min-height: 800px; */
      justify-content: center;
      gap: 20px;
      /* padding: 20px; */
      /* padding: 0px 20px; */
      align-items: center;
      flex-direction: column;

      > span {
        position: absolute;
        top: 50%;
        color: #ffffff;
        font-size: 14px;
        line-height: 20px;
      }
    }

    .wrapper {
      flex-grow: 1;

      margin: 0 auto;

      .title-container {
        display: flex;
        margin-right: auto;
        height: 60px;
        /* padding: 0px 20px; */

        .title-wrapper {
          display: flex;
          flex-direction: column;
          gap: 2px;
          font-family: Poppins;

          .title {
            min-width: 200px;
            max-width: 600px;
            height: 30px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            font-size: 20px;
            font-weight: 600;
          }

          .title-content {
            font-size: 12px;
            font-weight: 400;
            display: flex;
            gap: 10px;

            .date-text {
              color: #44444480;
              font-size: 12px;
              font-weight: 400;
            }
          }
        }
      }

      .content {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 20px;

        .media-wrapper {
          flex-grow: 1;

          display: flex;
          justify-content: center;
          flex-direction: column;
          align-items: center;

          position: relative;

          aspect-ratio: 1142 / 640;
          width: 100%;

          .media-wrapper-inner {
            flex-grow: 1;

            width: 100%;

            .audio-wrapper {
              align-items: center;
              justify-content: center;
              position: relative;

              .audio-player-wrapper {
                display: flex;
                flex-direction: column;
                align-items: center;
                gap: 4px;

                position: absolute;

                width: 100%;

                .audio-player-description {
                  color: white;
                  font-size: 16px;
                  text-align: center;
                }
              }
            }

            .skeleton-wrapper {
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
            }
          }

          .video-info {
            position: absolute;
            /* top: 50%; */
            margin: auto;
            color: white;
            font-size: 16px;
            text-align: center;
          }

          .thumbnail-wrapper {
            filter: brightness(70%);
            max-width: 1370px;
            max-height: 768px;
            width: 100%;
            height: 640px;
            /* aspect-ratio: 1142 / 640; */
            /* min-width: 1142px; */
            object-fit: contain;
          }

          .video-el {
            max-width: 1370px;
            max-height: 768px;
            width: 100%;
            /* height: 640px; */
            aspect-ratio: 1142 / 640;
          }

          .video-title-wrapper {
            width: 100%;
            text-align: center;
            border-radius: 8px;
          }

          .video-title {
            width: 100%;
            display: flex;
            justify-content: space-between;
            /* max-width: 900px; */
            /* text-align: center; */
            /* align-items: center; */

            /* padding-left: 20px; */
            /* padding-right: 20px; */
            display: flex;
            /* align-items: center; */
            justify-content: center;
            flex-direction: column;

            .title {
              display: flex;
            }

            .user-info {
              display: flex;
              gap: 8px;
              line-height: 0px;

              .user-id {
                font-size: 12px;
              }

              .vertical-line {
                /* height: 100%; */
                /* border-left: 1px solid rgba(68, 68, 68, 0.5);  */
                color: rgba(68, 68, 68, 0.5);
              }
              .created {
                font-size: 12px;
                color: rgba(68, 68, 68, 0.5);
                /* border-left: 10px solid rgba(68, 68, 68, 0.5); */
              }
            }
          }

          h1.ant-typography {
            text-align: center;
            /* margin-top: 40px; */
            /* flex: 1; */
            /* margin: 10px; */
            font-size: 20px;
            font-family: ${poppins_600.style.fontFamily};
            font-style: ${poppins_600.style.fontStyle};
            font-weight: ${poppins_600.style.fontWeight};
          }

          .share-button-wrapper {
            /* display: flex; */
            margin-left: auto;
            /* height: 50px; */
            /* justify-content: flex-end; */
            /* margin-right: 20px; */
            /* margin-bottom: 10px; */
          }

          .share-template-wrapper {
            width: 100%;
            max-width: 900px;
            height: 200px;
            /* margin-top: 20px; */
            text-align: center;
            margin: auto;
          }

          .video-template-card {
            cursor: pointer;
          }
        }

        .comment-wrapper {
          flex-shrink: 0;
          align-self: stretch;

          width: 332px;
          max-height: 640px;
          /* width: 100%; */
          /* height: auto; */
          aspect-ratio: 414 / 640;
          background-color: white;
          padding: 10px;
          border-radius: 8px;
          box-shadow: 0px 2px 10px 0px #00000026;

          overflow: hidden;

          &::-webkit-scrollbar {
            width: 1px;
          }

          &::-webkit-scrollbar-track {
            background: transparent;
          }

          &::-webkit-scrollbar-thumb {
            background-color: transparent;
          }
          .title {
            height: 40px;
            padding: 0px 12px 12px 12px;
            display: flex;
            justify-content: space-between;
            align-items: flex-start;

            h1.ant-typography {
              font-family: ${poppins_500.style.fontFamily};
              font-style: normal;
              font-weight: 500;
              font-size: 16px;
              line-height: 24px;
              padding: 0;
              margin: 0;
              color: #222222;
            }

            h2.ant-typography {
              font-family: ${poppins_500.style.fontFamily};
              font-style: normal;
              font-weight: 500;
              font-size: 12px;
              line-height: 24px;
              padding: 0;
              margin: 0;
              color: #222222;
            }
          }

          .user-input-box {
            border: 0.5px solid rgba(68, 68, 68, 0.27);
            border-radius: 6px;
            padding: 10px;
            /* height: 120px; */
            /* border-bottom: 1px solid  rgba(68, 68, 68, 0.27); */
            width: 100%;
            height: 140px;
            font-size: 12px;
            font-family: Poppins;

            .user {
              display: flex;
              align-items: center;
              height: 20px;
            }

            .user-bottom {
              width: 100%;
              /* height: 26px; */
              padding: 0 10px;
              display: flex;
              justify-content: flex-end;
              align-items: center;
              gap: 3px;
              /* background-color: wheat; */

              .comment-button {
                width: 90px;
                border-radius: 5px;
                background-color: #3075f6;
                display: flex;
                color: #ffffff;
                justify-content: center;
                align-items: center;
                border: 1px solid #3075f6;

                &.ant-btn-loading {
                  background-color: #3075f640;
                  border: 1px solid transparent;
                }

                &:disabled {
                  background-color: #3075f6;
                  border: 1px solid transparent;
                }

                &:hover {
                  opacity: 0.7;
                }
              }
            }

            .submit {
              min-width: 160px;
              display: flex;
              gap: 1vw;
              justify-content: flex-end;

              .time {
                display: flex;
                align-items: center;
                font-size: 10px;
                gap: 2px;
                font-family: ${poppins_400.style.fontFamily};
                font-style: ${poppins_400.style.fontStyle};
                font-weight: ${poppins_400.style.fontWeight};
              }

              .btn {
                background-color: #3075f6;
                box-shadow: 0px 4px 8px 0px #0000001a;
                color: white;
                width: 76px;
                height: 32px;
                border-radius: 8px;
                font-size: 10px;
                font-family: ${poppins_600.style.fontFamily};
                font-style: ${poppins_600.style.fontStyle};
                font-weight: ${poppins_600.style.fontWeight};
              }
            }
          }

          .comments-list {
            /* width: 100%; */
            display: flex;
            align-items: center;
            justify-content: flex-start;
            flex-direction: column;
            overflow-y: hidden;
            max-height: 520px;
            margin-top: 20px;
            height: calc(100% - 200px);

            /* padding-right: 20px; */

            /* height: auto; */
            /* height: calc(100% - 200px); */
          }

          .comments-list:hover {
            overflow-y: auto;
            scroll-behavior: auto;
            scroll-snap-coordinate: 10% 10%;

            &::-webkit-scrollbar {
              height: 4px;
              width: 10px;
            }

            &::-webkit-scrollbar-track {
              background-color: #ebebeb;
              border-radius: 10px;
              box-shadow: inset 0px 0px 5px white;
            }

            &::-webkit-scrollbar-thumb {
              background-color: #00000033;
              border-radius: 10px;
              background-clip: padding-box;
              border: 2px solid transparent;
            }
          }

          .no-comments {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            gap: 10px;
            margin-top: 20px;

            .no-comments-image {
              margin-top: 10px;
            }

            .main-txt {
              font-size: clamp(16px, 1.3em, 20px);

              line-height: 16px;
              justify-content: center;
              text-align: center;
              font-family: ${poppins_400.style.fontFamily};
              font-style: ${poppins_400.style.fontStyle};
              font-weight: ${poppins_400.style.fontWeight};
            }
            .sub-txt {
              font-size: clamp(10px, 1rem, 14px);
              line-height: 25px;
              font-family: ${poppins_400.style.fontFamily};
              font-style: ${poppins_400.style.fontStyle};
              font-weight: ${poppins_400.style.fontWeight};
              /* color: rgba(76, 81, 117, 0.5); */
              color: #44444460;
              padding: 20px 10px;
              text-align: center;
            }
          }
          /* .btn-container {
            display: flex;
            justify-content: flex-end; */

          .comment-btn {
            display: flex;
            background-color: #f4f4f4;
            border: none;
            width: 100px;
            height: 26px;
            padding: 3px 10px;
            margin: 0 auto;
            justify-content: center;
          }
          /* } */
        }
      }

      .create-account-button {
        border-radius: 10px;
        background-color: #3075f6;
        border: 1px solid #3075f6;
        height: 40px;
        /* width: 140px; */
        color: #ffffff;
        display: flex;
        justify-content: center;
        align-items: center;
        /* margin: 10px; */
        font-weight: 500;
        margin-top: 10px;
        margin-left: auto;
      }
    }
  }

  .mobile-container {
    width: 100%;
    height: 100%;
    /* padding: 0 30px; */
    display: flex;

    padding-inline: 5%;

    .thumbnail-wrapper {
      display: flex;
      width: 100%;
      /* min-height: 800px; */
      justify-content: center;
      gap: 20px;
      /* padding: 20px; */
      /* padding: 0px 20px; */
      align-items: center;
      flex-direction: column;

      > span {
        position: absolute;
        top: 50%;
        color: #ffffff;
        font-size: 14px;
        line-height: 20px;
      }
    }

    .wrapper {
      flex-grow: 1;

      margin: 0 auto;

      .title-container {
        display: flex;

        height: 60px;
        margin: 20px auto 0 auto;
        /* padding: 0px 20px; */

        .title-wrapper {
          display: flex;
          flex-direction: column;
          gap: 2px;
          font-family: Poppins;

          .title {
            font-size: 20px;
            font-weight: 600;
            height: 30px;
            overflow: hidden;
          }

          .title-content {
            font-size: 12px;
            font-weight: 400;
            display: flex;
            gap: 10px;

            .date-text {
              color: #44444480;
              font-size: 12px;
              font-weight: 400;
            }
          }
        }
      }

      .content {
        display: flex;
        justify-content: center;
        align-items: center;
        /* gap: 20px; */
        flex-direction: column;

        .media-wrapper {
          flex-grow: 1;

          justify-content: center;
          flex-direction: column;
          align-items: center;
          margin: 0 auto;
          display: flex;
          height: auto;
          flex: 0 0 auto;
          position: relative;
          /* aspect-ratio: 9 / 16; */

          aspect-ratio: 1142 / 640;
          width: 100%;

          .media-wrapper-inner {
            flex-grow: 1;

            width: 100%;

            .audio-wrapper {
              align-items: center;
              justify-content: center;
              position: relative;

              .audio-player-wrapper {
                display: flex;
                flex-direction: column;
                align-items: center;
                gap: 4px;

                position: absolute;

                width: 100%;

                .audio-player-description {
                  color: white;
                  font-size: 16px;
                  text-align: center;
                }
              }
            }

            .skeleton-wrapper {
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
            }
          }

          .video-info {
            position: absolute;
            /* top: 50%; */
            margin: auto;
            color: white;
            font-size: 16px;
            text-align: center;
          }

          .thumbnail-wrapper {
            filter: brightness(70%);
            /* max-width: 1142px;
            max-height: 640px; */
            width: 100%;
            /* height: 640px; */
            /* aspect-ratio: 9 / 16; */
            /* min-width: 1142px; */
            object-fit: contain;
          }

          .video-el {
            /* max-width: 1142px;
            max-height: 640px; */
            width: 100%;
            /* height: 640px;
            aspect-ratio: 1142 / 640; */
          }

          .video-title-wrapper {
            width: 100%;
            text-align: center;
            border-radius: 8px;
          }

          .video-title {
            width: 100%;
            display: flex;
            justify-content: space-between;
            /* max-width: 900px; */
            /* text-align: center; */
            /* align-items: center; */

            /* padding-left: 20px; */
            /* padding-right: 20px; */
            display: flex;
            /* align-items: center; */
            justify-content: center;
            flex-direction: column;

            .title {
              display: flex;
            }

            .user-info {
              display: flex;
              gap: 8px;
              line-height: 0px;

              .user-id {
                font-size: 12px;
              }

              .vertical-line {
                /* height: 100%; */
                /* border-left: 1px solid rgba(68, 68, 68, 0.5);  */
                color: rgba(68, 68, 68, 0.5);
              }
              .created {
                font-size: 12px;
                color: rgba(68, 68, 68, 0.5);
                /* border-left: 10px solid rgba(68, 68, 68, 0.5); */
              }
            }
          }

          h1.ant-typography {
            text-align: center;
            /* margin-top: 40px; */
            /* flex: 1; */
            /* margin: 10px; */
            font-size: 20px;
            font-family: ${poppins_600.style.fontFamily};
            font-style: ${poppins_600.style.fontStyle};
            font-weight: ${poppins_600.style.fontWeight};
          }

          .share-button-wrapper {
            /* display: flex; */
            margin-left: auto;
            /* height: 50px; */
            /* justify-content: flex-end; */
            /* margin-right: 20px; */
            /* margin-bottom: 10px; */
          }

          .share-template-wrapper {
            width: 100%;
            max-width: 900px;
            height: 200px;
            /* margin-top: 20px; */
            text-align: center;
            margin: auto;
          }

          .video-template-card {
            cursor: pointer;
          }
        }

        .comment-wrapper {
          flex-shrink: 0;
          align-self: stretch;

          /* width: 414px; */
          margin: 20px auto;
          /* max-height: 640px; */
          width: 100%;
          /* height: auto; */
          aspect-ratio: 414 / 640;
          background-color: white;
          padding: 10px;
          border-radius: 8px;
          box-shadow: 0px 2px 10px 0px #00000026;

          overflow: hidden;

          &::-webkit-scrollbar {
            width: 1px;
          }

          &::-webkit-scrollbar-track {
            background: transparent;
          }

          &::-webkit-scrollbar-thumb {
            background-color: transparent;
          }
          .title {
            height: 40px;
            padding: 0px 12px 12px 12px;
            display: flex;
            justify-content: space-between;
            align-items: flex-start;

            h1.ant-typography {
              font-family: ${poppins_500.style.fontFamily};
              font-style: normal;
              font-weight: 500;
              font-size: 16px;
              line-height: 24px;
              padding: 0;
              margin: 0;
              color: #222222;
            }

            h2.ant-typography {
              font-family: ${poppins_500.style.fontFamily};
              font-style: normal;
              font-weight: 500;
              font-size: 12px;
              line-height: 24px;
              padding: 0;
              margin: 0;
              color: #222222;
            }
          }

          .user-input-box {
            border: 0.5px solid rgba(68, 68, 68, 0.27);
            border-radius: 6px;
            padding: 10px;
            /* height: 120px; */
            /* border-bottom: 1px solid  rgba(68, 68, 68, 0.27); */
            width: 100%;
            height: 140px;
            font-size: 12px;
            font-family: Poppins;

            .user {
              display: flex;
              align-items: center;
              height: 20px;
            }

            .user-bottom {
              width: 100%;
              /* height: 26px; */
              padding: 0 10px;
              display: flex;
              justify-content: flex-end;
              align-items: center;
              gap: 3px;
              /* background-color: wheat; */

              .comment-button {
                width: 90px;
                border-radius: 5px;
                background-color: #3075f6;
                display: flex;
                color: #ffffff;
                justify-content: center;
                align-items: center;
                border: 1px solid #3075f6;

                &.ant-btn-loading {
                  background-color: #3075f640;
                  border: 1px solid transparent;
                }

                &:disabled {
                  background-color: #3075f6;
                  border: 1px solid transparent;
                }

                &:hover {
                  opacity: 0.7;
                }
              }
            }

            .submit {
              min-width: 160px;
              display: flex;
              gap: 1vw;
              justify-content: flex-end;

              .time {
                display: flex;
                align-items: center;
                font-size: 10px;
                gap: 2px;
                font-family: ${poppins_400.style.fontFamily};
                font-style: ${poppins_400.style.fontStyle};
                font-weight: ${poppins_400.style.fontWeight};
              }

              .btn {
                background-color: #3075f6;
                box-shadow: 0px 4px 8px 0px #0000001a;
                color: white;
                width: 76px;
                height: 32px;
                border-radius: 8px;
                font-size: 10px;
                font-family: ${poppins_600.style.fontFamily};
                font-style: ${poppins_600.style.fontStyle};
                font-weight: ${poppins_600.style.fontWeight};
              }
            }
          }

          .comments-list {
            /* width: 100%; */
            display: flex;
            align-items: center;
            justify-content: flex-start;
            flex-direction: column;
            overflow-y: hidden;
            max-height: 520px;
            margin-top: 20px;
            height: calc(100% - 200px);

            /* padding-right: 20px; */

            /* height: auto; */
            /* height: calc(100% - 200px); */
          }

          .comments-list:hover {
            overflow-y: auto;
            scroll-behavior: auto;
            scroll-snap-coordinate: 10% 10%;

            &::-webkit-scrollbar {
              height: 4px;
              width: 10px;
            }

            &::-webkit-scrollbar-track {
              background-color: #ebebeb;
              border-radius: 10px;
              box-shadow: inset 0px 0px 5px white;
            }

            &::-webkit-scrollbar-thumb {
              background-color: #00000033;
              border-radius: 10px;
              background-clip: padding-box;
              border: 2px solid transparent;
            }
          }

          .no-comments {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            gap: 10px;
            margin-top: 20px;

            .no-comments-image {
              margin-top: 10px;
            }

            .main-txt {
              font-size: 20px;
              line-height: 16px;
              font-family: ${poppins_400.style.fontFamily};
              font-style: ${poppins_400.style.fontStyle};
              font-weight: ${poppins_400.style.fontWeight};
            }
            .sub-txt {
              font-size: 14px;
              line-height: 25px;
              font-family: ${poppins_400.style.fontFamily};
              font-style: ${poppins_400.style.fontStyle};
              font-weight: ${poppins_400.style.fontWeight};
              /* color: rgba(76, 81, 117, 0.5); */
              color: #44444460;
              padding: 20px 10px;
              text-align: center;
            }
          }
          /* .btn-container {
            display: flex;
            justify-content: flex-end; */

          .comment-btn {
            display: flex;
            background-color: #f4f4f4;
            border: none;
            width: 100px;
            height: 26px;
            padding: 3px 10px;
            margin: 0 auto;
            justify-content: center;
          }
          /* } */
        }
      }

      .create-account-button {
        border-radius: 10px;
        background-color: #3075f6;
        border: 1px solid #3075f6;
        height: 40px;
        /* width: 140px; */
        color: #ffffff;
        display: flex;
        justify-content: center;
        align-items: center;
        /* margin: 10px; */
        font-weight: 500;
        margin-top: 10px;
        margin-left: auto;
      }
    }
  }

  .title {
    font-family: Poppins;
    font-size: 20px;
  }

  .sub-text {
    width: 80%;
    font-family: Poppins;
    font-size: 14px;
    color: rgba(68, 68, 68, 0.5);
    text-align: center;
  }

  .unauthorized-container {
    img {
      width: 128px;
      height: 128px;
    }

    width: 500px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 20px;

    .Request-button {
      background-color: rgba(48, 117, 246, 1);
      font-family: Poppins;
      font-size: 14px;
      font-weight: 500;
      width: 190px;
      height: 44px;
      padding: 10px 16px;
      border-radius: 10px;
      color: white;
    }
  }
`;

interface ShareButtonProps {
  buttonColor?: string;
  color?: string;
  onClick: () => void;
}

export const ShareButton = styled(Button)<ShareButtonProps>`
  /* background-color: #1478D4; */
  background-color: ${(props) => props.buttonColor};

  width: 125px;
  height: 40px;
  color: ${(props) => props.color || "black"};
  border-radius: 100px;
  height: 40px;
  max-height: 50px;
  font-family: ${poppins_400.style.fontFamily};
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  margin: 10px;
  padding: 10px;
  display: flex;
  gap: 3px;
  align-items: center;
  justify-content: center;
  min-width: 120px;

  & > img {
    width: 20px; /* Adjust the width as needed */
    height: auto; /* Adjust the height as needed */
    margin-right: 8px;
  }

  & > span {
    font-size: 14px;
  }

  &:hover {
    color: #ffffff;
    & > img {
      stroke: blue;
    }
  }
`;

export const CommentsList = styled.div`
  display: flex;
  align-items: center;
  /* justify-content: center; */
  /* flex-direction: column; */
  height: 100%;

  .no-comments {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 3px;

    .no-comments-image {
    }

    .main-txt {
      font-size: 20px;
      line-height: 16px;
      font-family: ${poppins_400.style.fontFamily};
      font-style: ${poppins_400.style.fontStyle};
      font-weight: ${poppins_400.style.fontWeight};
    }
    .sub-txt {
      font-size: 16px;
      line-height: 16px;
      font-family: ${poppins_400.style.fontFamily};
      font-style: ${poppins_400.style.fontStyle};
      font-weight: ${poppins_400.style.fontWeight};
      color: rgba(76, 81, 117, 0.5);
    }
  }
`;

export const ShareTemplateProfileIcon = styled.div`
  display: flex;
  width: 32px;
  height: 32px;
  justify-content: center;
  align-items: center;
  background-color: #f2c94c;
  border-radius: 16px;
  /* margin-right: 5px; */

  .alphabet {
    color: white;
    font-weight: 600;
    font-size: 16px;
  }
`;

export const StyledCommentDiv = styled.div`
  padding: 12px;
  width: 100%;

  .user-wrapper {
    display: flex;
    gap: 5px;
    align-items: center;
    justify-content: flex-start;

    .user-id {
      display: flex;
      justify-content: center;
      flex-direction: column;
      font-size: 12px;
    }

    .video-timer {
      display: flex;
      justify-content: center;
      background-color: #bec2d230;
      color: #686d8b;
      font-size: 10px;
      border-radius: 100px;
      width: 50px;
      align-items: center;
      height: 23px;
      cursor: pointer;
    }

    .comment-date {
      display: flex;
      justify-content: center;
      flex-direction: column;
      color: #c4c4c4;
      margin-left: 3px;
      font-size: 10px;
    }

    .more-icon {
      display: flex;
      justify-content: center;
      flex-direction: column;
      margin-left: auto;
      font-size: 16px;
      cursor: pointer;
    }
  }

  .user-comment {
    margin-top: 10px;
    font-size: 12px;
    font-family: ${poppins_400.style.fontFamily};
    font-style: ${poppins_400.style.fontStyle};
    font-weight: ${poppins_400.style.fontWeight};
    /* background-color: honeydew; */
  }

  .comment-info {
    margin-top: 10px;
    display: flex;

    .comment-video-time {
      background-color: #f1f2f3;
      width: 110px;
      height: 25px;
      border-radius: 10px;
      font-size: 10px;
      display: flex;
      align-content: center;
      justify-content: center;
      align-items: center;
      padding: 4px;
      color: #444444;
    }

    .comment-count-wrap {
      display: flex;
      align-content: center;
      justify-content: center;
      align-items: center;
      margin-left: auto;
      .comment-count {
        margin-left: 4px;
      }
    }
  }

  .user-recomment-wrapper {
    width: 90%;
    margin-left: auto;

    .recomment-item {
      margin-top: 10px;

      .head {
        display: flex;
        gap: 5px;
        .user-id {
          display: flex;
          justify-content: center;
          flex-direction: column;
          font-size: 12px;
        }

        .comment-date {
          display: flex;
          justify-content: center;
          flex-direction: column;
          color: #c4c4c4;
          margin-left: 3px;
          font-size: 10px;
        }

        .more-icon {
          display: flex;
          justify-content: center;
          flex-direction: column;
          margin-left: auto;
          font-size: 16px;
          cursor: pointer;
        }
      }

      .content {
        margin-top: 4px;
        margin-left: 4px;
      }
    }
  }

  .recomment-input {
    margin-top: 10px;
    width: 90%;
    margin-left: auto;
    .re-input {
      width: 70%;
    }
  }
`;

export const UserTextArea = styled(Input.TextArea)<{ textLength?: number }>`
  resize: none;
  border: none;
  padding: 10;
  margin: 10px;
  width: 95%;
  /* height: 50px; */
  opacity: ${({ textLength }) => (textLength === 0 ? 0.7 : 1)};

  &::-webkit-input-placeholder {
    line-height: normal;
  }

  &[disabled] {
    background-color: #ffffff; /* Red color */
  }
`;
